import { createAIDTTheme } from './createAIDTTheme';

import type { PaletteMode, Theme } from '@mui/material';
import type { ElicePaletteName } from '@elice/mui-system';
import { AIDTPaletteLevel, AIDTPalettePublisher, AIDTPaletteSubject } from '../types/theme.types';
import { TypographyFontFamilyType } from '../typography';

export interface CreateEliceThemeProps {
  paletteMode?: PaletteMode;
  paletteName?: ElicePaletteName;
  palettePublisher?: AIDTPalettePublisher;
  paletteSubject?: AIDTPaletteSubject;
  paletteLevel?: AIDTPaletteLevel;
  typographyFontFamily?: TypographyFontFamilyType;
}

/**
 * Override createEliceTheme to use createAIDTTheme instead
 * This ensures the override works in both development and production builds
 */
export const createEliceTheme = ({
  paletteMode = 'light',
  palettePublisher = 'elice',
  paletteSubject = 'korean',
  paletteLevel = 'elementary',
  typographyFontFamily = 'pretendard',
}: CreateEliceThemeProps = {}): Theme => {
  
  return createAIDTTheme({
    paletteMode,
    palettePublisher: palettePublisher,
    paletteSubject: paletteSubject,
    paletteLevel: paletteLevel,
    typographyFontFamily: typographyFontFamily
  });
};

// Re-export the original function as well, in case it's needed
export { createEliceTheme as originalCreateEliceTheme } from '@elice/mui-system';
